import styled from 'styled-components';
import { animated } from 'react-spring';

const Ring = styled(animated.div)`
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.splashRing};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default Ring;
